module.exports = __webpack_public_path__ + "img/1.afe0ca4b.png";